<template>
  <b-container>
    <b-row class="justify-content-center mt-5 mb-5">
      <b-img alt="Responsive image" fluid src="/favicon.ico"></b-img>
    </b-row>
    <b-row class="justify-content-center">
      <b-card title="Accueil">
        <p>Bienvenue sur le site de gestion de l'association poureux</p>
        <div></div>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
export default {};
</script>

<style></style>
